<div class="icon-container">
  <div
    [ngClass]="cssClass"
    [class.focusable-element]="isFocusableElement"
    [tabindex]="isFocusableElement ? 0 : -1"
  ></div>
</div>
